const AvailabilityStatusConstant = {
    AVAILABLE: 'AVAILABLE',
    IN_COMING: 'IN_COMING',
    UNAVAILABLE: 'UNAVAILABLE'
  }

export default AvailabilityStatusConstant
